<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :before-close="closeDialog"
      width="1220px"
      @opened="initLoad"
    >
      <div class="title bigTitle" style="margin-top:-30px">
        {{ warningTypeText }}
      </div>
      <div class="topSlot kuang">
        <el-row type="flex" justify="space-around">
          <el-col :span="12" class="colStyle">
            <li>
              <span class="detail-title">预警详情</span
              ><span>{{ warningBrief }}</span>
            </li>
            <li>
              <span class="detail-title">预警时间</span
              ><span>{{ warningTime }}</span>
            </li>
            <li>
              <span class="detail-title">处置状态</span
              ><span>{{ warnStatus }}</span>
            </li>
            <li>
              <span class="detail-title">相关企业名称</span
              ><span>{{ organName }}</span>
            </li>
          </el-col>
          <el-col :span="12" class="colStyle">
            <li>
              <span class="detail-title">统一社会信用代码</span
              ><span>{{ taxNo }}</span>
            </li>
            <li>
              <span class="detail-title">企业类型</span
              ><span>{{ entType }}</span>
            </li>
            <li>
              <span class="detail-title">法定代表人</span
              ><span>{{ entPrincipal }}</span>
            </li>
            <li>
              <span class="detail-title">联系人</span><span>{{ contact }}</span>
            </li>
            <li>
              <span class="detail-title">联系电话</span><span>{{ phone }}</span>
            </li>
            <li>
              <span class="detail-title">企业地址</span
              ><span>{{ entAddress }}</span>
            </li>
          </el-col>
        </el-row>
      </div>
      <component
        :is="warningType"
        :licenceUrl="licenceUrl"
        :warningId="warningId"
        :productList="productList"
        :currentTime="currentTime"
        ref="warningTypeComponent"
      />
      <div class="bottomSlot kuang">
        <div class="title">预警处置记录</div>
        <ul class="bottomSlot-list">
          <li class="list-ltem" v-for="item in recordList" :key="item.id">
            <span class="list-ltem-title">{{ item.createTime }}</span>
            <span class="list-ltem-text"
              >{{ item.warningDealDesc }}
              <el-button
                type="primary"
                size="mini"
                v-if="item.bizId"
                @click="checkLicence(item)"
                >查看</el-button
              ></span
            >
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dispose()">处 置</el-button>
        <el-button @click="closeDialog">返 回</el-button>
      </span>
    </el-dialog>
    <DealWaring
      :dialogVisible="showDeal"
      :closeDialog="closeDialog1"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showCancelFlag="false"
      :warningId="warningId"
    />
  </div>
</template>

<script>
import LicenceWarn from './warning-type/licence';
import RawAccessoryWarn from './warning-type/raw-accessory';
import TemperatureTumidity from './warning-type/temperature-humidity';
import ProductDefect from './warning-type/product-defect';
import OverdueStock from './warning-type/overdue-stock';
import OverdueSale from './warning-type/overdue-sale';
import CirculateSupplier from './warning-type/circulate-supplier';
import DealWaring from './deal';

// 流通-非指定供应商
// 经营范围超限
// 召回品销售
// 进销不平衡
// 洁净度超限
// 原辅料检验不合格
// 成品检验不合格
// 以上暂时没有
export default {
  props: {
    visible: Boolean,
    warningId: String,
    closeDialog: Function
  },
  data() {
    return {
      waringBigType: '',
      warningTypeText: '',
      warningBrief: '',
      warningTime: '',
      warnStatus: '',
      organName: '',
      taxNo: '',
      entType: '',
      entPrincipal: '',
      contact: '',
      phone: '',
      entAddress: '',
      warningType: '',
      licenceUrl: '',
      productList: [],
      currentTime: new Date(),
      show: false,
      showDeal: false,
      recordList: [],
      abnormalType: ''
    };
  },
  methods: {
    initLoad() {
      this.waringBigType = this.$route.params.waringBigType;
      this.loadEntDetail();
      this.loadWarnDetail();
      this.loaderWarnDealList();
    },
    // 企业基本信息
    loadEntDetail() {
      this.$request({
        url: 'rest/riskwarning/detail/queryEntInfoByWarningId',
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: 1, pageSize: 100000 },
            params: { warningId: this.warningId }
          })
        }
      }).then(res => {
        this.warningTypeText = this.$common.getWarningTypeText(
          res.abnormalType,
          res.entType
        );
        this.organName = res.organName;
        this.taxNo = res.taxNo;
        this.entType = this.$common.entTypeMap[res.entType];
        this.entPrincipal = res.entPrincipal;
        this.contact = res.contact;
        this.phone = res.phone;
        this.entAddress = res.entAddress;
        this.currentTime = new Date();
        const abnormalType = res.abnormalType;
        this.abnormalType = abnormalType;
        if (abnormalType === '12' || abnormalType === '21') {
          // 营业执照过期或临期
          this.warningType = 'LicenceWarn';
          this.licenceUrl = res.businessLicensePhotoUrl;
        } else if (abnormalType === '13' || abnormalType === '22') {
          // 药品生产许可证过期
          this.warningType = 'LicenceWarn';
          this.licenceUrl = res.licencePhotoUrl;
        } else if (
          (abnormalType === '15' && this.waringBigType === 'production') ||
          abnormalType === '10' ||
          abnormalType === '8'
        ) {
          // 四种原辅料异常或者成品检验不合格
          this.warningType = 'RawAccessoryWarn';
        } else if (
          abnormalType === '15' &&
          this.waringBigType === 'circulate'
        ) {
          // 流通预警非指定供应商
          this.warningType = 'CirculateSupplier';
        } else if (abnormalType === '9') {
          // 成品检测报告缺失
          this.warningType = 'ProductDefect';
        } else if (abnormalType === '11') {
          // 过效期库存
          this.warningType = 'OverdueStock';
        } else if (abnormalType === '14') {
          // 温湿度异常
          this.warningType = 'TemperatureTumidity';
        } else if (abnormalType === '2') {
          // 过效期销售
          this.warningType = 'OverdueSale';
        }
      });
    },
    // 企业预警信息
    loadWarnDetail() {
      this.$request({
        url: 'rest/riskwarning/detail/getRiskWarnById',
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: 1, pageSize: 100000 },
            params: {
              warningId: this.warningId
            }
          })
        }
      }).then(res => {
        this.warningBrief = res.warnJson;
        this.warningTime = res.warnTime;
        this.warnStatus = res.warnStatus;
        this.productList = res.warnList ? [JSON.parse(res.warnList)] : [];
      });
    },
    // 预警处置记录
    loaderWarnDealList() {
      this.$request({
        url: 'rest/riskWarningDeal/queryWarnDealStatusById',
        data: {
          json: JSON.stringify({
            params: {
              warningId: this.warningId
            }
          })
        }
      }).then(res => {
        this.recordList = res ? [...res] : [];
      });
    },
    dispose() {
      this.showDeal = true;
    },
    // 关闭弹框
    closeDialog1(isReload) {
      if (isReload === 'isReload') {
        this.loaderWarnDealList();
      }
      this.showDeal = false;
    },
    checkLicence(item) {
      console.log(item);
      const isPdfView = this.abnormalType === '7' || this.abnormalType === '9';
      if (isPdfView) {
        this.pdfView(this.abnormalType, item.id);
      } else {
        this.imageView(this.abnormalType, item.id);
      }
    },
    pdfView(abnormalType, id) {
      this.$blobFileRequest({
        url: 'open/riskWarningDeal/getWarnDealReportById',
        data: {
          abnormalType,
          id
        },
        isPdfView: true
      });
    },
    imageView(abnormalType, id) {
      this.$request({
        url: 'rest/riskWarningDeal/getWarnDealLicenseById',
        data: {
          abnormalType,
          id
        }
      }).then(res => {
        console.log(res);
        window.open(res.url);
      });
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal && this.warningType === 'TemperatureTumidity') {
        this.$refs.warningTypeComponent.$refs.echartsOption1.echarts.dispose();
        this.$refs.warningTypeComponent.$refs.echartsOption2.echarts.dispose();
      }
    }
  },
  components: {
    DealWaring,
    LicenceWarn,
    RawAccessoryWarn,
    TemperatureTumidity,
    ProductDefect,
    OverdueStock,
    OverdueSale,
    CirculateSupplier
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
</style>
